import { graphql } from '../../graphql/__generated__';

export const DiffFrag = graphql(`
  fragment DiffFrag on Diff {
    id
    ...DiffViewFragment
    ...DiffStageMetaFragment
  }
`);

export const ReadDiffDocument = graphql(/* GraphQL */ `
  query ReadDiffDocument($id: UUID!) {
    diff(id: $id) {
      ...DiffFrag
    }
  }
`);
